import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  const toggleSidebar = () => {
    setSidebarExpanded(!sidebarExpanded);
  };

  return (
    <div className="flex h-screen bg-background">
      <Sidebar expanded={sidebarExpanded} onToggle={toggleSidebar} />
      <div className="flex flex-1 flex-col">
        <Header sidebarExpanded={sidebarExpanded} />
        {/* <main
          className={`flex-1 overflow-y-auto p-6 transition-all ${
            sidebarExpanded ? 'ml-64' : 'ml-16'
          }`}
        > */}
        <main
          className={`flex-1 overflow-y-auto p-6 transition-all ${
            sidebarExpanded ? 'ml-0' : 'ml-0'
          }`}
        >
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
